import { render } from "./Loader.vue?vue&type=template&id=77902b05&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=77902b05&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77902b05"]])

export default __exports__